/* eslint-disable import/prefer-default-export */
import { WebUiConfig } from '@eql-ai/typescript-types';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { getFirestoreInstance } from '../firebase';

export const getWebUiConfigByClientId = async (
    clientId: string,
): Promise<WebUiConfig | null> => {
    try {
        const db = getFirestoreInstance();
        const querySnapshot = await getDocs(
            query(
                collection(db, 'web_ui_configs'),
                where('client_id', '==', clientId),
            ),
        );

        if (querySnapshot.size === 0) {
            return null;
        }

        if (querySnapshot.size > 1) {
            throw new Error(
                `More than 1 configs found with client_id: ${clientId}`,
            );
        }

        let webUiConfig: WebUiConfig | null = null;

        querySnapshot.forEach((doc) => {
            webUiConfig = doc.data() as WebUiConfig;
        });

        return webUiConfig;
    } catch (error) {
        // TODO - write to logger/exceptions
        console.log(error);
    }

    return null;
};
